import estateNova from "../assets/images/estate-nova.png";
import drShkodrani from "../assets/images/dr-shkodrani.png";
import Holidaze from "../assets/images/holidaze.png";
import AlethraLink from "../assets/images/AlethraLink.png";
import VivaNapoli from "../assets/images/viva-napoli-pizza.png";
import gtNordics from "../assets/images/gt-nordics.png";
import lokalnotodden from "../assets/images/lokalnotodden.png";
import spaceX from "../assets/images/spaceX.png";
import laiout from "../assets/images/laiout.png";
import letha from "../assets/images/letha.png";
import yay from "../assets/images/YAY.png";
import winterSports from "../assets/images/winter-sports.png";

const projects = [
  {
    id: 1,
    image: estateNova,
    project: "EstateNova",
    url: "https://estate-nova-project.vercel.app/",
    description:
      "Luxury real estate React template with cinematic layouts, premium property showcases, agent dashboards and elegant UI crafted for modern agencies and developers.",
    tech: ["react", "styled", "design"],
  },

  {
    id: 2,
    image: drShkodrani,
    project: "Dental Clinic - Dr. Shkodrani",
    url: "https://dr-shkodrani.vercel.app/",
    description:
      "Modern dental clinic website with clean UI and appointment-focused design.",
    tech: ["react", "styled", "design"],
  },
  {
    id: 3,
    image: VivaNapoli,
    project: "Viva Napoli Pizza",
    url: "https://viva-napoli-pizza.vercel.app/",
    description:
      "Stylish pizzeria landing page with rich visuals and smooth user experience.",
    tech: ["react", "styled", "design"],
  },
  {
    id: 4,
    image: Holidaze,
    project: "World Class Accommodations - Holidaze",
    url: "https://holidaze.florent-hajdari.com/",
    description:
      "Booking platform using React and WordPress API with dynamic listings.",
    tech: ["react", "wordpress", "api"],
  },
  {
    id: 5,
    image: AlethraLink,
    project: "Alethralink",
    url: "https://alethralink.vercel.app/",
    description:
      "Corporate tech website with modern UI, animations and strong branding.",
    tech: ["react", "styled", "animation"],
  },
  {
    id: 6,
    image: gtNordics,
    project: "G.T Nordics AS",
    url: "https://gt-nordics-as.vercel.app/",
    description:
      "Professional business website focused on services and performance.",
    tech: ["react", "styled", "design"],
  },
  {
    id: 7,
    image: lokalnotodden,
    project: "Lokal-Notodden",
    url: "https://lokalnotodden.no/",
    description:
      "Local business directory with filtering, categories and map integration.",
    tech: ["react", "styled", "api"],
  },
  {
    id: 8,
    image: spaceX,
    project: "Galaxy SpaceX",
    url: "https://space-x-project.vercel.app/",
    description:
      "Futuristic landing page with animations and engaging UI effects.",
    tech: ["react", "sass", "api"],
  },
  {
    id: 9,
    image: laiout,
    project: "Laiout",
    url: "https://laiout-one.vercel.app/",
    description:
      "Minimal SaaS-style layout focused on clean structure and typography.",
    tech: ["react", "sass", "design"],
  },
  {
    id: 10,
    image: letha,
    project: "Letha Shoemaker",
    url: "https://letha-shoes-sandy.vercel.app/",
    description:
      "Elegant product showcase website with premium look and smooth UX.",
    tech: ["react", "sass", "design"],
  },
  {
    id: 11,
    image: yay,
    project: "The YAY Company",
    url: "https://yay-company.vercel.app/",
    description:
      "Creative landing page with bold design and modern UI elements.",
    tech: ["react", "sass", "design"],
  },
  {
    id: 12,
    image: winterSports,
    project: "Winter Sports",
    url: "https://winter-sports.vercel.app/",
    description:
      "Dynamic winter-themed website with responsive and engaging visuals.",
    tech: ["react", "sass", "design"],
  },
];

export default projects;

// {
//   id: 7,
//   image: solheimfeltet,
//   project: "Solheimfeltet",
//   url: "https://www.solheimfeltet.no/",
// },

// {
//   id: 13,
//   image: aquaPharm,
//   project: "Aqua Pharm",
//   url: "https://aquapharm-ks.com/",
// },
